"use client";

import React from "react";
import { AccordionService } from "./AccordionService";

export const AccordionController = (): null =>
{
    React.useLayoutEffect(() =>
    {
        const controllers = Array.from(document.querySelectorAll<HTMLDivElement>("[data-logic-feature='accordion']")).map(element => new AccordionService(element));

        return () =>
        {
            controllers.forEach(controller => controller.dispose());
        };
    }, []);

    return null;
}